import { ActivitiesEventCountEventRes, Data } from '@quickService/ActivitiesEventCountEvent';
import { post } from '@lib/http';
import useSWR from 'swr';
import { returnApiUrl, baseUrl } from 'src/model/activity';

export type ActivityInfoData = ActivitiesEventCountEventRes;
interface CountQuery {
  query_view: number; // 1 主办方视角 2 观众视角
  host_id: string; // 主办方id
}
interface CountParams extends CountQuery {
  eventType?: Number; // -1为0.5版本活动  0为新版本活动
}
export const getKey = (params: CountParams, url: string) =>
  `${url}?hostId=${params.host_id}&query=${params.query_view}`;
/**
 * 活动列表总数
 */

export function useActivityCount(params: CountParams): {
  activityCount?: Data;
  error: unknown;
  mutate: Function;
} {
  // prettier-ignore
  const url = returnApiUrl('count_event');
  const { data, error, mutate } = useSWR(
    { url, params },
    async () => {
      if (!params?.host_id) return Promise.resolve(undefined);
      const res = await post<ActivitiesEventCountEventRes>(baseUrl, url, params);
      if (res?.code !== 0 || !res) {
        const error = new Error(res?.msg || '服务错误');
        throw error;
      }
      return res?.data;
    },
    {
      revalidateOnFocus: false,
    },
  );
  return {
    activityCount: data,
    error,
    mutate,
  };
}
